export default __webpack_public_path__ + "static/media/ganapathi.78ebddc0.png";